/*
 * Galerie nach Variante
 *
 * Die Produktgalerie zeigt nur die Bilder, die zur gewaehlten Variante gehoeren.
 * Welches Bild zu welchem Optionswert gehoert, steht im Alt-Text des Bildes
 * ("BambooMulti - Blau"). Ein Alt-Text ohne Optionswert ist ein gemeinsames
 * Bild (Gravurbild) und bleibt immer sichtbar.
 *
 * Reihenfolge: Hauptbild der Variante, dann die gemeinsamen Bilder, dann die
 * weiteren Ansichten derselben Variante.
 *
 * Den ersten Zustand rendert snippets/galerie-nach-variante.liquid. Dieses
 * Skript uebernimmt erst, wenn das Theme seine Slick-Slider aufgebaut hat, und
 * baut sie bei jedem Variantenwechsel neu.
 */
(function () {
  'use strict';

  var $ = window.jQuery;
  if (!$) return;

  var knoten = document.getElementById('galerie-nach-variante-daten');
  if (!knoten) return;

  var daten;
  try {
    daten = JSON.parse(knoten.textContent);
  } catch (e) {
    return;
  }
  if (!daten || !daten.bilder || !daten.bilder.length) return;

  /* Slick-Einstellungen — identisch zu assets/engo-scripts.js. */
  var HAUPT_OPTIONEN = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dot: false,
    fade: false,
    infinite: false,
    asNavFor: '.box-thumbnail-pr'
  };
  var THUMB_OPTIONEN = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product-img-box',
    dots: false,
    fade: false,
    infinite: false,
    focusOnSelect: true
  };

  /* Optionen, deren Werte reine Zahlen sind (Anzahl, Menge), sagen nichts
     ueber das Bild aus und bleiben aussen vor. */
  var wortoptionen = daten.optionen.filter(function (option) {
    return option.werte.some(function (wert) {
      return !/^\s*\d+\s*$/.test(wert);
    });
  });

  /* Nennt der Alt-Text diesen Wert als eigenes Wort? Anders als das Liquid
     achtet die Pruefung hier auf Wortgrenzen, damit "Rot" nicht in
     "Rotbraun" trifft. */
  var WORTZEICHEN = /[\p{L}\p{N}]/u;
  function nenntWert(alt, wert) {
    if (!alt || !wert) return false;
    var text = alt.toLowerCase();
    var suche = wert.toLowerCase();
    var von = text.indexOf(suche);
    while (von !== -1) {
      var davor = von === 0 ? '' : text.charAt(von - 1);
      var danach = text.charAt(von + suche.length);
      if (!WORTZEICHEN.test(davor) && !WORTZEICHEN.test(danach)) return true;
      von = text.indexOf(suche, von + 1);
    }
    return false;
  }

  /* Der laengste Treffer gewinnt, damit "Hellgruen" nicht als "Gruen" gilt. */
  function genannterWert(alt, werte) {
    var treffer = null;
    werte.forEach(function (wert) {
      if (nenntWert(alt, wert) && (!treffer || wert.length > treffer.length)) {
        treffer = wert;
      }
    });
    return treffer;
  }

  /* Die Leitoption ist die ERSTE Wortoption — die Stiftfarbe, bei reinen
     Boxprodukten die Box. Sie bestimmt, wie der Stift aussieht.

     Nicht die meistgenannte nehmen: bei MetalSet nennen 70 Bilder die Box und
     69 die Stiftfarbe, weil das Gravurbild "ohne Box" mitfuehrt. Die Zaehlung
     kippt dort auf die falsche Option.

     Ein Bild, das einen Optionswert nennt, aber NICHT den der Leitoption, ist
     ein Beispielbild: das Gravurbeispiel, die Farbdruck-Ansichten. Solche
     Bilder gehoeren direkt hinter das Hauptbild, nicht ans Ende. Sonst haengt
     ihre Position davon ab, an welcher Stelle sie zufaellig im Produkt liegen —
     das Gravurbild stand deshalb vorn, die Farbdruck-Bilder hinten. */
  var leitoption = wortoptionen[0] || null;

  function aktuelleVariante() {
    var feld = document.getElementById('productSelect');
    var id = feld && feld.value ? String(feld.value) : null;
    var gefunden = null;
    if (id) {
      daten.varianten.forEach(function (v) {
        if (String(v.id) === id) gefunden = v;
      });
    }
    if (gefunden) return gefunden;

    /* Kein brauchbares Formularfeld: aus den angehakten Swatches lesen. */
    var werte = [];
    daten.optionen.forEach(function (option, i) {
      var haken = document.querySelector(
        '.swatch[data-option-index="' + i + '"] input:checked'
      );
      werte[i] = haken ? haken.value : null;
    });
    daten.varianten.forEach(function (v) {
      if (gefunden) return;
      var alleGleich = werte.every(function (wert, i) {
        return wert === null || wert === v.werte[i];
      });
      if (alleGleich) gefunden = v;
    });
    return gefunden || daten.varianten[0] || null;
  }

  function reihenfolgeFuer(variante) {
    if (!variante) return daten.bilder.slice();

    var haupt = null;
    var gemeinsam = [];
    var weitere = [];

    daten.bilder.forEach(function (bild) {
      var passt = true;
      var hatWert = false;

      wortoptionen.forEach(function (option) {
        var stelle = daten.optionen.indexOf(option);
        var genannt = genannterWert(bild.alt, option.werte);
        if (!genannt) return;
        hatWert = true;
        if (genannt !== variante.werte[stelle]) passt = false;
      });

      if (!passt) return;
      var nenntLeit = leitoption ? !!genannterWert(bild.alt, leitoption.werte) : false;
      if (variante.bild !== null && String(bild.id) === String(variante.bild)) {
        haupt = bild;
      } else if (hatWert && nenntLeit) {
        weitere.push(bild);
      } else {
        /* gemeinsame Bilder und Beispielbilder der Veredelung */
        gemeinsam.push(bild);
      }
    });

    /* Ist der Variante kein Bild zugeordnet, gilt ihr erstes eigenes Bild als
       Hauptbild — sonst stuende ein gemeinsames Bild wie das Gravurbild vorn. */
    if (!haupt && weitere.length) haupt = weitere.shift();

    var liste = (haupt ? [haupt] : []).concat(gemeinsam, weitere);
    /* Sicherheitsnetz: bliebe nichts uebrig, zeigen wir alles. */
    return liste.length ? liste : daten.bilder.slice();
  }

  function kennung(liste) {
    return liste
      .map(function (b) {
        return b.id;
      })
      .join('|');
  }

  var $haupt, $thumb;
  var gezeigt = null;

  function galerieSetzen(liste) {
    if ($haupt.hasClass('slick-initialized')) $haupt.slick('unslick');
    if ($thumb.hasClass('slick-initialized')) $thumb.slick('unslick');

    var gross = '';
    var klein = '';
    liste.forEach(function (bild) {
      var alt = $('<div/>').text(bild.alt || daten.titel).html();
      gross +=
        '<div><a href="javascript:void(0)">' +
        '<img class="img-fluid engoj_img_main" src="' + bild.src + '" alt="' + alt + '"/>' +
        '</a></div>';
      klein +=
        '<div class="engoj-nav-item thumnail-img"><a href="javascript:void(0)" class="thumbnail">' +
        '<img class="img-fluid" src="' + bild.src + '" alt="' + alt + '"/>' +
        '</a></div>';
    });

    $haupt.html(gross);
    $thumb.html(klein);
    $haupt.slick(HAUPT_OPTIONEN);
    $thumb.slick(THUMB_OPTIONEN);
    gezeigt = kennung(liste);
  }

  function aktualisieren() {
    var liste = reihenfolgeFuer(aktuelleVariante());
    if (kennung(liste) === gezeigt) return;
    galerieSetzen(liste);
  }

  /* Erst uebernehmen, wenn das Theme seine Slider gebaut hat — sonst wuerde
     die Theme-Initialisierung eine zweite Slick-Instanz darauflegen. */
  function wennBereit(weiter) {
    var versuche = 0;
    (function warten() {
      $haupt = $('.product-img-box');
      $thumb = $('.box-thumbnail-pr');
      if (!$haupt.length || !$thumb.length) return;
      if ($haupt.hasClass('slick-initialized') || versuche >= 40) {
        weiter();
        return;
      }
      versuche += 1;
      window.setTimeout(warten, 100);
    })();
  }

  /* Zum Nachsehen in der Browserkonsole und fuer Tests. */
  window.galerieNachVariante = {
    daten: daten,
    reihenfolgeFuer: reihenfolgeFuer,
    aktuelleVariante: aktuelleVariante,
    aktualisieren: aktualisieren
  };

  $(function () {
    wennBereit(function () {
      /* Was Liquid gerendert hat, ist bereits der richtige Stand. */
      gezeigt = kennung(reihenfolgeFuer(aktuelleVariante()));
      $(document).on(
        'change',
        '#productSelect, .single-option-selector, .swatch input:radio',
        function () {
          window.setTimeout(aktualisieren, 0);
        }
      );
    });
  });
})();
